import { dateFormat } from "./dateFormat";
import { formatServiceType } from "./customerHealperFunctions";

export function formatOrderAddress(address) {
  if (!address) return "—";
  const formatted = [
    address.address_line,
    address.house_no,
    address.street_address,
    address.landmark,
    address.city,
    address.state,
    address.pincode || address.zipcode,
  ]
    .filter(Boolean)
    .join(", ");
  return formatted || "—";
}

export function resolvePickupAddress(order) {
  const pickups = order?.pickups || [];
  const customerPickup = pickups.find(
    (pickup) => pickup?.pickup_type !== "Store_Pickup"
  );

  return formatOrderAddress(
    customerPickup?.pickup_address ||
      order?.pickup?.pickup_address ||
      order?.pickup_address ||
      order?.user_address
  );
}

export function resolveDeliveryAddress(order) {
  const pickups = order?.pickups || [];
  const storeDelivery = pickups.find(
    (pickup) => pickup?.pickup_type === "Store_Pickup"
  );
  const customerPickup = pickups.find(
    (pickup) => pickup?.pickup_type !== "Store_Pickup"
  );

  return formatOrderAddress(
    storeDelivery?.delivery_address ||
      customerPickup?.delivery_address ||
      order?.pickup?.delivery_address ||
      order?.delivery_address ||
      order?.user_address
  );
}

export function mapOrderToViewDetails(order) {
  const address = formatOrderAddress(order?.user_address);

  return {
    id: order?.id,
    order_id: order?.order_id,
    order_status: order?.status,
    date: dateFormat(order?.created_at) || "",
    address,
    contact: order?.user?.phone_number,
    customer_name: order?.user?.name,
    customer_img: order?.user?.profile_img_url,
    service_type: order?.services?.service_type,
    service: formatServiceType(order?.services?.service_type),
    delivery_time: formatTimeSlot(order?.delivery_time_slot),
    delivery_date: dateFormat(order?.deliveryDate) || "",
    totalPrice: parseInt(order?.total_amount, 10) || 0,
    totalQuantity:
      order?.services?.items?.reduce(
        (acc, item) => acc + (item.quantity || 0),
        0
      ) || 0,
    items: order?.services?.items,
    additionalItems: order?.additionalItems || [],
    laundryNotes: order?.laundryNotes,
    isMismatchExist: Boolean(order?.mismatch),
    breakdown: order?.breakdown || {},
  };
}

export function formatTimeSlot(slot) {
  if (!slot) return "";
  const { open, close } = slot;
  if (open && close) return `${open} - ${close}`;
  return open || close || "";
}

export function formatDateTime(dateValue, timeSlot) {
  const datePart = dateValue ? dateFormat(dateValue) : "";
  const timePart = formatTimeSlot(timeSlot);
  if (datePart && timePart) return `${datePart} · ${timePart}`;
  return datePart || timePart || "—";
}

export function getPartnerFromPickups(pickups, partnerType) {
  if (!Array.isArray(pickups) || !pickups.length) {
    return { assigned: false, name: "", display: "Not assigned" };
  }

  const isDelivery = partnerType === "delivery";
  const match = pickups.find((pickup) =>
    isDelivery
      ? pickup?.pickup_type === "Store_Pickup"
      : pickup?.pickup_type !== "Store_Pickup"
  );

  const name =
    match?.deliveryPerson?.name || match?.deliveryPerson?.user?.name || "";

  return {
    assigned: Boolean(name),
    name,
    display: name ? name : "Not assigned",
  };
}

export function resolvePickupSchedule(order) {
  const pickups = order?.pickups || [];
  const customerPickup = pickups.find(
    (pickup) => pickup?.pickup_type !== "Store_Pickup"
  );

  const dateValue =
    customerPickup?.pickup_date ||
    order?.pickup_date ||
    order?.pickup?.pickup_date ||
    "";
  const timeSlot =
    customerPickup?.pickup_time_slot ||
    order?.pickup_time_slot ||
    order?.pickup?.pickup_time_slot;

  return formatDateTime(dateValue, timeSlot);
}

export function resolveDeliverySchedule(order) {
  return formatDateTime(order?.deliveryDate, order?.delivery_time_slot);
}
